export type PaginatedSearchResultMetadataDto = {
    PageSize: number
    ActivePage: number
    TotalItemsCount: number
}


export default class PaginatedSearchResultMetadata {
    data: PaginatedSearchResultMetadataDto
    constructor(dto: PaginatedSearchResultMetadataDto) {
        this.data = dto
    }

    getPageSize(): number {
        return this.data.PageSize
    }

    getActivePage(): number {
        return this.data.ActivePage
    }

    getTotalItemsCount(): number {
        return this.data.TotalItemsCount
    }
}


// WEBPACK FOOTER //
// ./src/state/search/PaginatedSearchResultMetadata.ts